
import React, {Component} from 'react';
import {DropdownButton,MenuItem} from 'react-bootstrap'

import ReportKKCIncome from './ReportKKCIncome'
import ReportKKCBalance from './ReportKKCBalance'
import ReportKKCAllYearProfit from './ReportKKCAllYearProfit'
import ReportKKCReceivableCash from './ReportKKCReceivableCash'
import ReportKKCBillingNoteReceivable from './ReportKKCBillingNoteReceivable'
import ReportKKCAllYearIncomeOverview from './ReportKKCAllYearIncomeOverview'
import ReportPOAndExpense from './ReportPOAndExpense'
import ReportKKCPurchaseOrderSummary from './ReportKKCPurchaseOrderSummary'
import ReportPendingWork from './ReportPendingWork'
import ReportPickup from './ReportPickup'
import ReportMechanicWork from './ReportMechanicWork'

const menuTilesArray = [
{id:0,title:'รายงานสรุปค่าใช้จ่ายของรถลูกค้าแต่ละคัน'},
{id:1,title:'รายงานสรุปรถออกรายได้คงเหลือ'},
{id:2,title:'รายงานสรุปรายรับรายจ่ายประจำปี'},
{id:3,title:'รายงานสรุปรายการรับเงิน'},
{id:4,title:'รายงานสรุปยอดใบวางบิลค้างรับ'},
{id:5,title:'รายงานสรุปรับรถเข้าซ่อม-ค่าใช้จ่ายจริง'},
{id:6,title:'รายงานสรุปรายจ่าย'},
{id:10,title:'รายงานงานค้าง'},
{id:100,title:'divider'},
{id:7,title:'รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (รวม)'},
{id:8,title:'รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (เครดิต 45 วัน)'},
{id:9,title:'รายงานสรุปยอดสั่งซื้อวัสดุ - อะไหล่ (เครดิต 60 วัน)'},
{id:101,title:'divider'},
{id:11,title:'รายงานช่างเบิกของ'},
{id:12,title:'รายงานช่างทำงาน'}]
class ReportPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {eventKey:-1, btnTitle:"เลือกรายงาน...", displayBtn:"inline"}
  }

  onMenuItemSelect(index){
    const item = menuTilesArray.find(function(element) {
      return element.id ===index;
    });
    
    this.setState({ eventKey:index*1, btnTitle:item.title, displayBtn:"none" })
  }  

  renderMenu(bsStyle){
    if(bsStyle===undefined){
      bsStyle = 'default'
    }
    return (
      <DropdownButton id="report" bsStyle={bsStyle} title={this.state.btnTitle} onSelect={this.onMenuItemSelect.bind(this)} >
      {menuTilesArray.map((item,index)=>{
        if(item.title==='divider'){
          return (<MenuItem key={index} divider />)
        }
        return (<MenuItem key={index} eventKey={item.id}>{item.title}</MenuItem>)
      })      
    }
    </DropdownButton>
    )
  }

  render(){
    let {eventKey} = this.state
    
    return (
      <div>
        <div style={{display:this.state.displayBtn}}>
         {this.renderMenu()}
        </div>
        <div style={{display:(eventKey===0)?'block':'none'}}>
          <ReportKKCIncome   
            show={eventKey===0}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===1)?'block':'none'}}>
          <ReportKKCBalance   
            show={eventKey===1}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===2)?'block':'none'}}>
          <ReportKKCAllYearProfit   
            show={eventKey===2}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===3)?'block':'none'}}>
          <ReportKKCReceivableCash   
            show={eventKey===3}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===4)?'block':'none'}}>
          <ReportKKCBillingNoteReceivable   
            show={eventKey===4}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===5)?'block':'none'}}>
          <ReportKKCAllYearIncomeOverview   
            show={eventKey===5}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===6)?'block':'none'}}>
          <ReportPOAndExpense   
            show={eventKey===6}          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===7)?'block':'none'}}>
          <ReportKKCPurchaseOrderSummary   
            show={eventKey===7}
            credit='all'          
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===8)?'block':'none'}}>
          <ReportKKCPurchaseOrderSummary   
            show={eventKey===8}     
            credit='45'     
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===9)?'block':'none'}}>
          <ReportKKCPurchaseOrderSummary   
            show={eventKey===9}       
            credit='60'   
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===10)?'block':'none'}}>
          <ReportPendingWork 
            show={eventKey===10}   
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===11)?'block':'none'}}>
          <ReportPickup 
            show={eventKey===11}   
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
        <div style={{display:(eventKey===12)?'block':'none'}}>
          <ReportMechanicWork 
            show={eventKey===12}   
            renderMenu={this.renderMenu.bind(this,'link')}
            keyChange={this.onMenuItemSelect.bind(this)}
          />
        </div>
      </div>
    )
  }
}


export default ReportPage;





// WEBPACK FOOTER //
// ./src/view/report/ReportPage.js